exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-danger[data-v-9922367a] {\n  display: block;\n  margin: 0.5rem 0 0 0.5rem;\n}\ninput[type=date][data-v-9922367a] {\n  max-width: 200px;\n}\ninput[type=number][data-v-9922367a] {\n  max-width: 100px;\n}\n.form-group[data-v-9922367a] {\n  margin-bottom: 24px;\n}\n.form-group label[data-v-9922367a] {\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n.form-control.error[data-v-9922367a] {\n  border: 1px solid #bf5329;\n}", ""]);

// exports
